export default {
  ORG_PRODUCT_TYPES(state, value) {
    state.orgProductTypes = value;
  },
  ORG_PRICE_TYPES(state, value) {
    state.orgPriceTypes = value;
  },
  ORG_PRODUCT_COUPONS(state, value) {
    state.orgProductCouponCodes = value;
  },
  ORG_PRODUCT_REDEMPTION_INSTRUCTIONS(state, value) {
    state.orgProductRedemptionInstructions = value;
  },
  ORG_PRODUCT_MINTABLE_CONTRACT_DETAILS(state, value) {
    state.orgProductMintableContractDetails = value;
  },
};
